import $ from 'jquery';
import '@fancyapps/fancybox';
import 'slick-carousel';
import 'jquery.cookie';
import '../js/app.westhaven-newslettersignup.js';
import '../js/app.sitehelp.js';

window.appJs = {};

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

window.appJs.SetFadeIn = function() {
	if ('IntersectionObserver' in window) {
		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting === true) {
					entry.target.classList.add("fade-in--is-visible");
				}
			});
		}, { threshold: [0.05] });
		var items = document.querySelectorAll(".fade-in");
		items.forEach(function (item, index) {
			observer.observe(item, index);
		});
	} else {
		document.querySelector("body").classList.add("no-intersection-observer");
	}
}
window.appJs.SetFadeIn();

/* ==========================================================================
   Intersection Observer - Change header on scroll
   ========================================================================== */

if ('IntersectionObserver' in window) {
	var headerEl = document.querySelector("header");
	var headerSentinalEl = document.querySelector(".header-sentinal");

	var videoHeaderhandler = function handler(entries) {
		if (!entries[0].isIntersecting) {
			headerEl.classList.add("header--scrolled");
		} else {
			headerEl.classList.remove("header--scrolled");
		}
	};

	var observer = new window.IntersectionObserver(videoHeaderhandler);
	observer.observe(headerSentinalEl);
} else {
	document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

if (document.querySelector(".js-trigger-mobile-nav")) {
	const navButton = document.querySelector(".js-trigger-mobile-nav");
	const navElement = document.querySelector(".main-nav");
	navButton.addEventListener("click",
		function() {
			navElement.classList.toggle("is-active");
			this.classList.toggle("is-active");
		});
}

/* ==========================================================================
   Sub Nav Toggle Button
   ========================================================================== */

// $(".js-toggle-subnav").click(function (e) {
// 	e.preventDefault();
// 	var thisNav = $(this).parent().find(".sub-nav");
// 	$(".main-nav__link").not(this).removeClass("main-nav__link--sub-nav-active");
// 	$(".sub-nav").not(thisNav).fadeOut();
// 	$(this).toggleClass("main-nav__link--sub-nav-active");
// 	$(this).parent().find(".sub-nav").fadeToggle();
// });
//
// $(".js-close-subnav").click(function (e) {
// 	e.preventDefault();
// 	$(".sub-nav").fadeOut();
// 	$(".main-nav__link").removeClass("main-nav__link--sub-nav-active");
// 	$(".header").removeClass("header--sub-nav-active");
// });

/* ==========================================================================
   Search toggle Button
   ========================================================================== */

$(".js-toggle-search").click(function () {
	$(".header-search").toggleClass("is-active");
	$("header").toggleClass("search-form-is-active");
	$(".main-nav__list").toggleClass("search-form-is-active");
	$(".header-search .search-form input").focus();
});


/* ==========================================================================
   Alert Close Button
   ========================================================================== */

if (document.querySelector(".js-close-alert-popup")) {
	document.querySelector(".js-close-alert-popup").addEventListener("click", function (event) {
		event.preventDefault();
		$(".alert-banner").hide();

		var cookieName = $(this).data("cookie");
		var date = new Date();
		var minutes = 120;
		date.setTime(date.getTime() + (minutes * 60 * 1000));
		$.cookie(cookieName, true, { expires: date, path: '/' });
	});
}

/* ==========================================================================
   Cookies Close Button
   ========================================================================== */

if (document.querySelector(".js-close-cookies-popup")) {
	document.querySelector(".js-close-cookies-popup").addEventListener("click", function (event) {
		event.preventDefault();
		$(".cookie-banner").hide();
		var cookieName = $(this).data("cookie");
		$.cookie(cookieName, true, { expires: 365, path: '/' });
	});
}

/* ==========================================================================
   Slick Sliders
   ========================================================================== */

if (document.querySelector(".js-news-slider")) {
	$('.js-news-slider').slick({
		dots: false,
		arrows: true,
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		prevArrow:
			'<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
		nextArrow:
			'<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>',
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}

$('.js-gallery-slider').slick({
	dots: false,
	arrows: true,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	prevArrow:
		'<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
	nextArrow:
		'<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>',
}).on('afterChange',
	function (event, slick, currentSlide) {
		var $progress_bar = $('#' + $(this).attr('aria-controls')),
			min = $progress_bar.attr('min'),
			max = $progress_bar.attr('max'),
			start = $progress_bar.data('start'),
			step = $progress_bar.attr('step'),
			progress = $(this).find('[data-progress]:eq(' + (currentSlide + 1) + ')').attr('data-progress');

		var value = (parseInt(progress) - parseInt(start));
		$progress_bar.attr('value', value);
	});



/* ==========================================================================
   FAQ
   ========================================================================== */

$('body').on('click', '.accordion__trigger', function () {
	var $button = $(this),
	 		$panel = $('#' + $button.attr('aria-controls'));

	if ($button.attr('aria-expanded') == 'true') {
		// close panel
			$panel.attr('hidden',  true);
			$panel.removeClass('is-open');
		// update trigger
			$button.attr('aria-expanded', false);
	} else {
		// open panel
			$panel.removeAttr('hidden');
			$panel.addClass('is-open');
		// update trigger
			$button.attr('aria-expanded', true);
	}
});


$(document).ready(function() {

	if ($(".js-current-weather").length) {
		$(".js-current-weather").load('/umbraco/surface/WeatherSurface/GetWeather');
	}

});
